module.exports = __webpack_public_path__ + "static/aisha-f021a0e0777f1a99e469081c09983bd8.png";